import isEmail from 'validator/lib/isEmail'

export default values => {
  const errors = {}

  if (!values.name) {
    errors.name = 'Name is required'
  }

  if (!values.email) {
    errors.email = 'Email is required'
  } else if (!isEmail(values.email)) {
    errors.email = 'Incorrect email address'
  }

  if (!values.password) {
    errors.password = 'Password is required'
  }

  if (!values.terms) {
    errors.terms = true
  }

  return errors
}



// WEBPACK FOOTER //
// ./client/views/AuthView/validate.js